import type { DashboardWidgetKey } from "@repo/shared/types";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./use-widget-text.i18n";

/** A widget's name, what it shows, and its short name in the layout preview. */
export function useWidgetText() {
  const all: Record<string, unknown> = useT(T);
  const text = (k: string) => (typeof all[k] === "string" ? (all[k] as string) : undefined);
  return (key: DashboardWidgetKey) => {
    const name = text(key) ?? key;
    return {
      name,
      shows: text(`${key}Shows`) ?? "",
      short: text(`${key}Short`) ?? name,
    };
  };
}
